var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bannerW"},[_c('el-image',{staticClass:"banner",attrs:{"src":require('@/assets/img/news.jpg'),"fit":"cover"}}),_c('AboutMenu',{attrs:{"menu":[
        '公司动态',
        '文化活动',
        '视频新闻',
        '行业动态',
        '信息公示',
        '企业内刊' ]}}),_c('div',{staticClass:"pageTitle",class:{ titleEn: _vm.lang == 'en' }},[_c('h2',[_vm._v("公司动态")]),_c('p',[_vm._v("COMPANY NEWS")])]),_c('div',{staticClass:"titleBox",class:{ titleEn: _vm.lang == 'en' }},[_c('h2',[_vm._v("砥砺奋进")]),_c('p',[_vm._v("SHEER ENDEAVOUR")])]),_c('div',{staticClass:"wrap"},[_c('Slide',{attrs:{"lang":_vm.lang}})],1),_c('NewsList',{attrs:{"lang":_vm.lang}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }